import { useContext } from 'react'
import {
  GlobalDataContext,
  TemplateContext,
  evaluateTemplateValue,
} from '@ea-lab/reactive-json'

/**
 * Generic primitive — renders an array (or scalar) as a joined string, with an
 * optional prefix shown only when there is something to display. Fills the gap
 * left by `Switch`, which skips non-object items (so a string[] can't be
 * iterated) and by YAML, which has no join/map. Reusable anywhere a list of
 * scalars must become inline text (active-filter summaries, tag lists…).
 *
 * YAML :
 *   - type: JoinText
 *     value: ~.filters.bu
 *     prefix: "BU : "
 *     separator: ", "     # default ", "
 *   # → renders "BU : a, b" ; renders nothing when the list is empty.
 */
export const JoinText = ({ props }) => {
  const globalDataContext = useContext(GlobalDataContext)
  const templateContext = useContext(TemplateContext)
  const resolve = (v) => evaluateTemplateValue({ valueToEvaluate: v, globalDataContext, templateContext })

  const value = resolve(props.value)
  const arr = Array.isArray(value)
    ? value
    : (value === null || value === undefined || value === '' ? [] : [value])
  if (!arr.length) return null

  const separator = resolve(props.separator) ?? ', '
  const prefix = resolve(props.prefix) ?? ''
  return <>{prefix}{arr.join(separator)}</>
}
